import { useEffect, useState } from "react";
import Locked_icon from "icons/Locked_icon.svg";

import styles from "./styles.module.scss";

function TileV1({
  title,
  value,
  unit,
  variant,
  hideBorder,
  isLocked,
  isWholeNumber,
  isLandscape,
  onCompare,
  isClubFittingScreen,
  styleVariant,
  isFirstColumn,
  origin,
}: any) {
  const [tooltipId, setTooltipId] = useState("");

  const innerContainerClassName = `${
    isClubFittingScreen ? styles.clubFittingTile : styles.tile
  } ${styles[`tile${variant}`]} ${isLocked ? styles.bgLock : ""}`;

  function getTileContainerClass() {
    return "tileContainer";
  }
  function getHeaderClass() {
    return isClubFittingScreen ? styles.clubFittingHeader : "";
  }

  const styleVariantObj: any = {
    "force-tile": "tileForForces",
    "tile-for-update-popup": "tileForModal",
    "inactive-tile-for-update-popup": "inactiveTileForModal",
    "results-highlights": "results-highlights",
  };

  const componentClass = styles[styleVariantObj[styleVariant]];

  return (
    <div
      className={
        [
          `${styles[getTileContainerClass()]} ${
            styles[variant]
          } ${componentClass}`,
        ] as any
      }
      id={`${tooltipId}-container`}
    >
      <ShowBorder hideBorder={hideBorder} variant={variant} />
      <div className={innerContainerClassName} style={{ height: "100%" }}>
        <div className={getHeaderClass()}>
          <h1 className={styles.tileName}>{title}</h1>
        </div>
        <ShowValue
          isLocked={isLocked}
          value={value}
          isWholeNumber={isWholeNumber}
          isFirstColumn={isFirstColumn}
        />
        <ShowUnit unit={unit} />
      </div>
    </div>
  );
}

function ShowBorder({ hideBorder, variant }: any) {
  if (hideBorder) {
    return <></>;
  }
  return (
    <div
      className={`${styles.borderLine} ${styles[`line${variant}`]}`}
      style={{ height: "90%" }}
    />
  );
}

function ShowValue({ isLocked, value, isWholeNumber, isFirstColumn }: any) {
  const fixedValue = (valueLocal: any) => {
    const digitsAfterDecimal = isWholeNumber ? 0 : 1;

    let finalValue = valueLocal ? Number(value).toFixed(digitsAfterDecimal) : 0;
    if (finalValue === "NaN") {
      return value;
    }

    if (isFirstColumn) {
      finalValue = valueLocal ? Number(value).toFixed(2) : 0;
    }
    return finalValue;
  };

  if (isLocked) {
    return (
      <div className={styles.lockedCircle}>
        <img src={Locked_icon} alt="Locked_icon" />
      </div>
    );
  }
  return <h1 className={styles.tileValue}>{fixedValue(value)}</h1>;
}

function ShowUnit({ unit }: any) {
  // if (!unit) {
  //   return <></>;
  // }
  return <h1 className={styles.tileUnit}>{unit ? unit : ""}</h1>;
}

export { TileV1 };
